import React, { Component } from "react";

// Local Components
import RichText from "./components/richText/richText";

class ProjectPreview extends Component {
  render() {
    return (
      <div className="content">
        <a href={`projects/${this.props.project.fields.slug}`}>
          <h1
            style={{
              marginTop: "0",
              fontSize: "2.5rem",
              lineHeight: "2rem"
            }}
          >
            {this.props.project.fields.title}
          </h1>
        </a>
        <RichText richText={this.props.project.fields.information} />
      </div>
    );
  }
}

export default ProjectPreview;
